import { createContext, useContext, useLayoutEffect } from "react";

const ContentEditorShellContext = createContext(null);

export const ContentEditorShellProvider = ContentEditorShellContext.Provider;

export const EMPTY_CONTENT_EDITOR_SIDEBAR_STATE = Object.freeze({
  unit: null,
  lesson: null,
  scenario: null,
  infoPage: null,
  lessonVersions: [],
  activeVersionId: null,
  /** Active roleplay's states/conditions (mirrors lessonVersions) so the sidebar can render the
   *  States/Conditions branches; only the active scenario provides these. */
  scenarioStates: [],
  scenarioConditions: [],
  scenarioActiveStateId: null,
  skillsSidebarSections: [],
  skillsActiveSkillId: null,
  skillsActiveGroupId: null,
  skillsSidebarRefresh: null,
  programPageSection: null,
  lessonSidebarReorder: null,
});

export const createContentEditorSidebarState = (overrides = {}) => ({
  ...EMPTY_CONTENT_EDITOR_SIDEBAR_STATE,
  ...(overrides || {}),
});

export const useContentEditorShell = () => {
  const value = useContext(ContentEditorShellContext);
  if (!value) {
    throw new Error("useContentEditorShell must be used inside ContentEditorShellProvider");
  }
  return value;
};

export const useOptionalContentEditorShell = () => useContext(ContentEditorShellContext);

export const useSyncContentEditorSidebarState = (sidebarState, { optional = false } = {}) => {
  const value = useOptionalContentEditorShell();
  if (!value && !optional) {
    throw new Error("useContentEditorShell must be used inside ContentEditorShellProvider");
  }
  const replaceSidebarState = value?.replaceSidebarState;

  useLayoutEffect(() => {
    if (!replaceSidebarState) return;
    replaceSidebarState(sidebarState);
  }, [replaceSidebarState, sidebarState]);
};

export default ContentEditorShellContext;
